import { Suspense, lazy } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import SEO from '../../utils/SEO'
import { LocalBusinessSchema, WebSiteSchema } from '../../utils/StructuredData'

// Critical above-fold components - load immediately
import Hero from './Hero'

// Lazy load Hype components (contain video, not critical for FCP)
const Hype = lazy(() => import('./Hype'))
const SmallHype = lazy(() => import('./SmallHypeV2'))
const AboutSummary = lazy(() => import('./AboutSummary'))

// Below-fold components - lazy load to improve initial load time
const BJJ101 = lazy(() => import('./BJJ101'))
const Location = lazy(() => import('./Location'))
const SocialMedia = lazy(() => import('../../SocialMedia'))
const Courses = lazy(() => import('./Courses'))
const Schedule = lazy(() => import('./Schedule'))
const GoogleReviews = lazy(() => import('./GoogleReviews'))
const Archive = lazy(() => import('./ShortArchive'))
const OtherResources = lazy(() => import('./OtherResources'))
const MailingList = lazy(() => import('../../MailingList'))
const SecondaryCTA = lazy(() => import('./SecondaryCTA'))

// Simple loading placeholder
const LoadingPlaceholder = () => (
  <Box sx={{ minHeight: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
)

function Home () {
  const smallScreen = !useMediaQuery('(min-width:600px)')

  return (
    <div>
      <SEO 
        title="Brazilian Jiu-Jitsu in Lake Oswego, Oregon"
        description="The Black Dog Jiu-Jitsu Company offers adult BJJ classes, beginner programs, and youth training in Lake Oswego, OR. Join our welcoming community and start your martial arts journey today."
        canonicalPath="/"
      />
      <LocalBusinessSchema />
      <WebSiteSchema />
      <Hero />
      
      {/* Hype and AboutSummary - lazy loaded but render quickly */}
      <Suspense fallback={<LoadingPlaceholder />}>
        {smallScreen ? <SmallHype /> : <Hype /> }
        <AboutSummary />
      </Suspense>
      
      {/* Below-fold content wrapped in Suspense for lazy loading */}
      <Suspense fallback={<LoadingPlaceholder />}>
        <BJJ101 />
        <Location />
        <SocialMedia />
        <Courses />
        <Schedule />
        <GoogleReviews />
        <Archive />
        <OtherResources />
        <MailingList />
        <SecondaryCTA />
      </Suspense>
    </div>
  )
}

export default Home
